/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/22/13
 * Time: 9:23 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");
    var CONST = require("const");

    var PersonaModel = BaseModel.extend({
        defaults : {
            className: "",
            relatedModuleName: "",
            switcherIndex: "",
            type : CONST.PERSONA.GUEST,
            displayNotifications: 0,
            notifications:{
                chats: 0,
                errors: 0
            }
        },
        name: "PersonaModel",
        initialize : function (options) {
            this.type = options.type;
            this.className = options.className;
        }
    });

    return PersonaModel;
});
